import { ToastrService } from 'ngx-toastr';

/**
 * @deprecated Requires injecting `ToastrService` as a parameter instead of using Angular's `inject()`.
 * French error message should be handled via i18n. Refactor to use Angular's DI and translation pipeline.
 */
// Function to open a window and check if it was blocked
export function openWindow(url: string, toastr: ToastrService): void {
  const popup = window.open(url, '_blank');
  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    // Popup was blocked
    toastr.error('La fenêtre pop-up a été bloquée par votre navigateur.', 'Erreur');
  }
}